import React from "react";
import Table from "components/common/Table";
import MarketingNavigation from "./MarketingNavigation";
import MarketingToolTip from "./MarketingToolTip";
import MarketingContainer from "./MarketingContainer";

const MarketingAnalytics = ({ columns, data, title }) => {
  return (
    <MarketingContainer>
      <MarketingNavigation>
        <MarketingToolTip>
          <small className="">
            <i className="fas fa-info-circle text-gray-600 pr-2" />
            Download the
            <b className="text-green-500 mx-1">
              audience
              <i className="fas fa-file-download mx-1" />
            </b>
            or
            <b className="text-red-500 mx-1">
              anayltics
              <i className="fas fa-chart-line mx-1" />
            </b>
            for previous batches.
          </small>
        </MarketingToolTip>
      </MarketingNavigation>
      <p className="text-6xl mb-3 mt-10 pl-3">{title}</p>
      <div className="flex flex-col justify-center my-2 bg-transparent rounded-lg ">
        {data && <Table id="sms-batches" data={data} columns={columns} />}
      </div>
    </MarketingContainer>
  );
};

export default MarketingAnalytics;
